<div fxLayout="column">

    <div fxLayout="row">
        <h2>Declaração</h2>
    </div>
    <form name="orderTissForm" [formGroup]="orderTissDeclarationForm" fxFlex="100"  fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="20px" autocomplete="off">

        <mat-form-field  appearance="outline" fxFlex="14">
            <mat-label>Declaração Nascido Vivo</mat-label>
            <input id="operational-reception-order_tiss_declaration-birthDeclaration-edit-form_it" matInput maxlength="20"
                   formControlName="birthDeclaration">
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex="30" class="mr-8"
        >
            <mat-label>CID Óbito</mat-label>

            <input matInput
                   id="operational-reception-order_tiss_declaration-cid-edit-form_it"
                   formControlName="cid"
                   [matAutocomplete]="autoCid" autocomplete="off"
                   type="search" />


            <mat-autocomplete autoActiveFirstOption
                              #autoCid="matAutocomplete"
                              [displayWith]="displayCIDFn">
                <mat-option *ngFor="let cid of cidList" [value]="cid">
                    {{cid.name}} | {{cid.code}}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <!--        <mat-form-field  appearance="outline" fxFlex="14">-->
        <!--            <mat-label>CID 10 Óbito</mat-label>-->
        <!--            <input id="operational-reception-order_tiss_declaration-cid-edit-form_it" matInput maxlength="20"-->
        <!--                   formControlName="cid">-->
        <!--        </mat-form-field>-->

        <mat-form-field  appearance="outline" fxFlex="14">
            <mat-label>Declaração de Óbito</mat-label>
            <input id="operational-reception-order_tiss_declaration-deathDeclaration-edit-form_it" matInput maxlength="20"
                   formControlName="deathDeclaration">
        </mat-form-field>

        <mat-form-field appearance="outline" class="mr-12" fxFlex="8">
            <mat-label>Óbito</mat-label>
            <mat-select id="operational-reception-order_tiss_declaration-dornIndicator-edit-form_cs"
                        [compareWith]="compareEnum" formControlName="dornIndicator">
                <mat-option [value]="'S'">
                    Sim
                </mat-option>
                <mat-option [value]="'N'">
                    Não
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div *ngIf="!loading">

            <button *ngIf="!modeEdit" matTooltip="Salvar" id="order_tiss_declaration-insert"   style="color: #1e527f;"
                    mat-stroked-button class="mr-12 button-tiss" (click)="insert()" >Adicionar
                <span class="material-icons">backup</span>
            </button>

            <button *ngIf="modeEdit" matTooltip="Salvar" id="order_tiss_declaration-edit"   style="color: #1e527f;"
                    mat-stroked-button class="mr-12 button-tiss" (click)="insert()" >Salvar
                <span class="material-icons">backup</span>
            </button>

            <button *ngIf="modeEdit" matTooltip="Salvar" id="order_tiss_declaration-cancel"   style="color: #1e527f;"
                    mat-stroked-button class="mr-12 button-tiss" (click)="cancel()" >Cancelar
                <span class="material-icons">close</span>
            </button>

        </div>

        <div *ngIf="loading"  fxLayoutAlign="space-evenly center">
            <mat-spinner [diameter]="20" class="mr-8"></mat-spinner>
            <p>Processando, aguarde...</p>
        </div>


    </form>

    <div fxLayout="row">
        <table mat-table [dataSource]="orderTissDeclarationList" class="compact-table">

            <ng-container matColumnDef="birthDeclaration">
                <th mat-header-cell *matHeaderCellDef> Declaração Nascido Vivo </th>
                <td mat-cell *matCellDef="let element"> {{element.birthDeclaration}} </td>
            </ng-container>

            <ng-container matColumnDef="cid">
                <th mat-header-cell *matHeaderCellDef> CID Óbito </th>
                <td mat-cell *matCellDef="let element"> {{element?.cid?.name}} </td>
            </ng-container>

            <ng-container matColumnDef="deathDeclaration">
                <th mat-header-cell *matHeaderCellDef> Declaração de Óbito </th>
                <td mat-cell *matCellDef="let element"> {{element.deathDeclaration}} </td>
            </ng-container>

            <ng-container matColumnDef="dornIndicator">
                <th mat-header-cell *matHeaderCellDef> Óbito </th>
                <td mat-cell *matCellDef="let element"> {{checkDornIndicator(element)}} </td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef>  </th>
                <td mat-cell *matCellDef="let element">
                    <button title="Editar" id="order_tiss_declaration-editar"   style="color: #1e527f;"
                            mat-stroked-button class="mr-12 button-tiss" (click)="edit(element)" >
                        Editar
                        <span class="material-icons">edit</span>
                    </button>

                    <button title="Editar" id="order_tiss_declaration-delete"   color="warn"
                            mat-stroked-button class="mr-12 button-tiss" (click)="confirDelete(element)" >
                        Apagar
                        <span class="material-icons">delete</span>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

    </div>


</div>